import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class TriangulationUtil {
  public static triangulateFromOrder(order, leg1, leg2): void {
    let destinationLeg = leg1.lastModified ? leg2 : leg1;
    let changedLeg = leg1.lastModified ? leg1 : leg2;
    this.triangulateLegs(changedLeg, destinationLeg, order);
  }

  public static triangulateLegs(changedLeg, destinationLeg, order): void {
    if (!this.hasRate(order) || !this.hasRate(changedLeg)) {
      return;
    }
    var calculatedRate: CubiqTS.BigNumber;
    let orderRate: CubiqTS.BigNumber = new CubiqTS.BigNumber(order.spotMarketRate);
    if (order.invertedOrder) {
      orderRate = new CubiqTS.BigNumber(1).dividedBy(orderRate);
    }

    if (
      (changedLeg.nonBaseCcyCd == destinationLeg.baseCcyCd ||
        destinationLeg.nonBaseCcyCd == changedLeg.baseCcyCd) &&
      order.nonBaseCcyCd != changedLeg.baseCcyCd &&
      order.nonBaseCcyCd != destinationLeg.baseCcyCd
    ) {
      calculatedRate = new CubiqTS.BigNumber(orderRate).dividedBy(changedLeg.spotMarketRate);
    } else if (
      (changedLeg.baseCcyCd == destinationLeg.baseCcyCd &&
        changedLeg.nonBaseCcyCd == order.baseCcyCd) ||
      (changedLeg.nonBaseCcyCd == destinationLeg.nonBaseCcyCd &&
        changedLeg.baseCcyCd == order.nonBaseCcyCd) ||
      ((changedLeg.nonBaseCcyCd == destinationLeg.baseCcyCd ||
        destinationLeg.nonBaseCcyCd == changedLeg.baseCcyCd) &&
        changedLeg.nonBaseCcyCd == order.baseCcyCd)
    ) {
      if (
        (changedLeg.nonBaseCcyCd == destinationLeg.baseCcyCd ||
          destinationLeg.nonBaseCcyCd == changedLeg.baseCcyCd) &&
        changedLeg.nonBaseCcyCd == order.baseCcyCd
      ) {
        calculatedRate = new CubiqTS.BigNumber("1.0").dividedBy(
          new CubiqTS.BigNumber(orderRate).times(changedLeg.spotMarketRate),
        );
      } else {
        calculatedRate = new CubiqTS.BigNumber(orderRate).times(changedLeg.spotMarketRate);
      }
    } else if (
      (changedLeg.baseCcyCd == destinationLeg.baseCcyCd &&
        changedLeg.nonBaseCcyCd == order.nonBaseCcyCd) ||
      (changedLeg.nonBaseCcyCd == destinationLeg.nonBaseCcyCd &&
        changedLeg.baseCcyCd == order.baseCcyCd) ||
      ((changedLeg.nonBaseCcyCd == destinationLeg.baseCcyCd ||
        destinationLeg.nonBaseCcyCd == changedLeg.baseCcyCd) &&
        changedLeg.baseCcyCd == order.nonBaseCcyCd)
    ) {
      if (
        (changedLeg.nonBaseCcyCd == destinationLeg.baseCcyCd ||
          destinationLeg.nonBaseCcyCd == changedLeg.baseCcyCd) &&
        changedLeg.baseCcyCd == order.nonBaseCcyCd
      ) {
        calculatedRate = new CubiqTS.BigNumber("1.0").dividedBy(
          new CubiqTS.BigNumber(orderRate).times(changedLeg.spotMarketRate),
        );
      } else {
        calculatedRate = new CubiqTS.BigNumber(changedLeg.spotMarketRate).dividedBy(orderRate);
      }
    }

    this.formatDestinationRate(destinationLeg, calculatedRate);
  }

  private static formatDestinationRate(destinationLeg, calculatedRate: CubiqTS.BigNumber): void {
    calculatedRate = new CubiqTS.BigNumber(calculatedRate.toFixed(9));
    let deciamls = calculatedRate.decimalPlaces();
    if (deciamls > 9) {
      deciamls = 9;
    } else if (deciamls < destinationLeg.minPrecision) {
      deciamls = destinationLeg.minPrecision;
    }
    destinationLeg.spotMarketRate = calculatedRate.toFixed(deciamls);
  }

  private static hasRate(item): boolean {
    let bn = new CubiqTS.BigNumber(item.spotMarketRate);
    if (bn.isEqualTo(0) || bn.isNaN()) return false;
    return true;
  }
}
